import { useCallback, useState } from 'react';

export const useDialogState = () => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [dialogData, setDialogData] = useState(null);

  const showDialog = useCallback((data = null) => {
    setIsDialogVisible(true);
    setDialogData(data);
  }, [setIsDialogVisible]);
  const hideDialog = useCallback((data = null) => {
    setIsDialogVisible(false);
    setDialogData(data);
  }, [setIsDialogVisible]);

  return {
    isDialogVisible,
    showDialog,
    hideDialog,
    dialogData,
  };
};
